/* eslint-disable import/prefer-default-export */
import { CreateMonitorReq } from '@src/endpoints/services/intentMgr.service'
import { UpdateMonitorOptions } from '@src/redux/actions/guardrails/monitoring.actions'
import { GuardrailEditModel, SeverityEnum } from '../../models'
import { AlertSeverityEnum, SuppressionTypeEnum } from '../configurations'

export function getSuppression(identity: boolean, object: boolean) {
  if (identity && object) return SuppressionTypeEnum.ALERT_SUPPRESSION_BOTH
  if (identity) return SuppressionTypeEnum.ALERT_SUPPRESSION_IDENTITY
  if (object) return SuppressionTypeEnum.ALERT_SUPPRESSION_OBJECT
  return SuppressionTypeEnum.ALERT_SUPPRESSION_NONE
}
interface CreateMonitorOptions extends CreateMonitorReq {}

export function getDataToServer(
  model: GuardrailEditModel
): UpdateMonitorOptions | CreateMonitorOptions {
  const data = { ...model }
  delete data.categories
  const {
    name,
    severity,
    query,
    id,
    description,
    suppressionDeleteObject,
    suppressionCreateObject,
    suppressionDeleteIdentity,
    suppressionCreateIdentity,
    label
  } = data

  return {
    ...data,
    name,
    severity: convertToAlertSeverityEnum(severity),
    query,
    monitor_id: id,
    description,
    suppression_create: getSuppression(
      suppressionCreateIdentity,
      suppressionCreateObject
    ),
    suppression_delete: getSuppression(
      suppressionDeleteIdentity,
      suppressionDeleteObject
    ),
    label
  }
}

export function convertToSeverityEnum(
  severity: AlertSeverityEnum
): SeverityEnum {
  switch (severity) {
    case AlertSeverityEnum.ALERT_SEVERITY_NONE: {
      return SeverityEnum.NONE
    }
    case AlertSeverityEnum.ALERT_SEVERITY_LOW: {
      return SeverityEnum.LOW
    }
    case AlertSeverityEnum.ALERT_SEVERITY_MEDIUM: {
      return SeverityEnum.MEDIUM
    }
    case AlertSeverityEnum.ALERT_SEVERITY_HIGH:
    default: {
      return SeverityEnum.HIGH
    }
  }
}

export function convertToAlertSeverityEnum(
  severity: SeverityEnum
): AlertSeverityEnum {
  switch (severity) {
    case SeverityEnum.NONE: {
      return AlertSeverityEnum.ALERT_SEVERITY_NONE
    }
    case SeverityEnum.LOW: {
      return AlertSeverityEnum.ALERT_SEVERITY_LOW
    }
    case SeverityEnum.MEDIUM: {
      return AlertSeverityEnum.ALERT_SEVERITY_MEDIUM
    }
    case SeverityEnum.HIGH:
    default: {
      return AlertSeverityEnum.ALERT_SEVERITY_HIGH
    }
  }
}
